import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {agent} from "../../../utils/agent";
import * as API from "../../../utils/apiPath";  

// Thunk for Login / Pre-Registration submit
export const submitUserForm = createAsyncThunk(
  "user/submitUserForm",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.LOGIN, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

const programSlice = createSlice({
  name: "program",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitUserForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitUserForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitUserForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed";
      });
  },
});

export default programSlice.reducer;
